module.exports = __webpack_public_path__ + "img/ICONO8.22783398.png";